import { render, staticRenderFns } from "./ConversationSidebar.vue?vue&type=template&id=dc69e240&scoped=true"
import script from "./ConversationSidebar.vue?vue&type=script&lang=ts"
export * from "./ConversationSidebar.vue?vue&type=script&lang=ts"
import style0 from "./ConversationSidebar.vue?vue&type=style&index=0&id=dc69e240&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc69e240",
  null
  
)

export default component.exports